import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";
import PropTypes from "baobab-react/prop-types";
import _ from "lodash";
import * as Utils from "../../utils/utils";

class PlayerItemGroup extends PureComponent {

	render() {
		const theme = this.props.activityTheme ? this.props.activityTheme : global.activityTheme;

		const { itemGroup } = theme;
		const { children, overrides, overrides2 } = this.props;
		let leadItemVisible = true;
		if (overrides && overrides.hasOwnProperty("visible") && !overrides.visible) {
			leadItemVisible = false;
		}

		if (overrides2 && overrides2.hasOwnProperty("visible") && !overrides2.visible) {
			leadItemVisible = false;
		}
		console.log("Render children", children);
		return leadItemVisible ? (
			<div style={itemGroup.container}>			
				{children}
			</div>
		) : null;
	}
	
}
PlayerItemGroup.contextTypes = {
	tree: PropTypes.baobab
};

export default branch(
	(props, context) => {
		let result = {
			columnWidth: Utils.getDefaultColumnWidthBranchPath(context.tree, props.sectionIndex)
		};
		if (props.leadItemGuid) {
			result.overrides = ["activity", "overrides", props.leadItemGuid];
		}
		if (props.leadItemId && !_.isEmpty(props.leadItemId)) {
			result.overrides2 = ["activity", "overrides", props.leadItemId];
		}

		return result;
	}, PlayerItemGroup);